export default __webpack_public_path__ + "static/media/jpg.7d1eea15.svg";